/* eslint-disable */
export default {
  save: 'Salvar',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
